export default "__VITE_ASSET__71KmWnTy__"